'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _fastDeepEqual = require('fast-deep-equal');

var _fastDeepEqual2 = _interopRequireDefault(_fastDeepEqual);

var _dateFns = require('date-fns');

var _metrixCommon = require('metrix-common');

var _Months_1_enCA = [{
    code: '1',
    value: 'January'
}, {
    code: '2',
    value: 'February'
}, {
    code: '3',
    value: 'March'
}, {
    code: '4',
    value: 'April'
}, {
    code: '5',
    value: 'May'
}, {
    code: '6',
    value: 'June'
}, {
    code: '7',
    value: 'July'
}, {
    code: '8',
    value: 'August'
}, {
    code: '9',
    value: 'September'
}, {
    code: '10',
    value: 'October'
}, {
    code: '11',
    value: 'November'
}, {
    code: '12',
    value: 'December'
}];

var _Months_1_enCA2 = _interopRequireDefault(_Months_1_enCA);

var _Months_1_frCA = [{
    code: '1',
    value: 'janvier'
}, {
    code: '2',
    value: 'f\xE9vrier'
}, {
    code: '3',
    value: 'mars'
}, {
    code: '4',
    value: 'avril'
}, {
    code: '5',
    value: 'mai'
}, {
    code: '6',
    value: 'juin'
}, {
    code: '7',
    value: 'julliet'
}, {
    code: '8',
    value: 'ao\xFBt'
}, {
    code: '9',
    value: 'septembre'
}, {
    code: '10',
    value: 'octobre'
}, {
    code: '11',
    value: 'novembre'
}, {
    code: '12',
    value: 'd\xE9cembre'
}];

var _Months_1_frCA2 = _interopRequireDefault(_Months_1_frCA);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WorkflowDate = function (_React$Component) {
    _inherits(WorkflowDate, _React$Component);

    function WorkflowDate(props) {
        _classCallCheck(this, WorkflowDate);

        var _this = _possibleConstructorReturn(this, (WorkflowDate.__proto__ || Object.getPrototypeOf(WorkflowDate)).call(this, props));

        _this.handleDate = function (year, month) {
            var daysInMonth = (0, _dateFns.getDaysInMonth)(new Date(year, month - 1)) || 31;
            _this.setState({ days: _this.getOptions(1, daysInMonth, 0) });
            var selectedDay = (0, _metrixCommon.getReturnElementByCode)(_this.props.return, 'Day');
            if (selectedDay && selectedDay > daysInMonth) {
                _this.props.doSetReturn({ componentCode: _this.props.component.code, code: 'Day', value: null });
            }
        };

        _this.state = {
            days: [],
            months: [],
            years: [],
            validateDay: false,
            validateMonth: false,
            validateYear: false
        };
        return _this;
    }

    _createClass(WorkflowDate, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.culture === 'en-CA') {
                this.setState({ months: _Months_1_enCA2.default });
            } else {
                this.setState({ months: _Months_1_frCA2.default });
            }
            var mode = (0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'Mode');
            var take = (0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'Take');
            var skip = (0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'Skip');
            var selector = (0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'Selector');

            if (!selector) selector = 'year';

            var currentYear = new Date().getFullYear();

            this.setState({ days: this.getOptions(1, 31, 0) });

            if (selector === 'year') {
                if (mode === 'future') {
                    this.setState({ years: this.getOptions(currentYear, take || 5, skip || 0) });
                } else if (mode === 'past') {
                    this.setState({ years: this.getOptions(currentYear - (take || 100) - (skip - 1 || 0), take || 100, 0).reverse() });
                } else {
                    this.setState({ years: this.getOptions(currentYear, 2, skip || 0) });
                }
            } else {
                this.setState({ years: this.getOptions(currentYear, 5, 0) });
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState, snapshot) {
            this.props.return && this.props.return.elements && this.props.doReduceDynamicDate((0, _metrixCommon.getElementValueByCode)(this.props.return.elements, 'DynamicDate'));
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            var selectedYear = (0, _metrixCommon.getReturnElementByCode)(this.props.return, 'Year') && { code: (0, _metrixCommon.getReturnElementByCode)(this.props.return, 'Year') };
            var selectedMonth = (0, _metrixCommon.getReturnElementByCode)(this.props.return, 'Month') && { code: (0, _metrixCommon.getReturnElementByCode)(this.props.return, 'Month') };
            if (selectedYear && selectedMonth) {
                var daysInMonth = (0, _dateFns.getDaysInMonth)(new Date(selectedYear.code, selectedMonth.code - 1));
                if (daysInMonth < this.state.days.length) {
                    this.setState({ days: this.getOptions(1, daysInMonth, 0) });
                    return true;
                }
            }

            return !(0, _fastDeepEqual2.default)(this.props, nextProps) || !(0, _fastDeepEqual2.default)(this.state, nextState);
        }
    }, {
        key: 'getOptions',
        value: function getOptions(start, take, skip) {
            var options = [];

            for (var i = 0; i < parseInt(take); i++) {
                var value = start + parseInt(skip) + i;
                options.push({ code: '' + value, value: '' + value });
            }

            return options;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var selectedYear = (0, _metrixCommon.getReturnElementByCode)(this.props.return, 'Year') && { code: (0, _metrixCommon.getReturnElementByCode)(this.props.return, 'Year') };
            var selectedMonth = (0, _metrixCommon.getReturnElementByCode)(this.props.return, 'Month') && { code: (0, _metrixCommon.getReturnElementByCode)(this.props.return, 'Month') };
            var selectedDay = (0, _metrixCommon.getReturnElementByCode)(this.props.return, 'Day') && { code: (0, _metrixCommon.getReturnElementByCode)(this.props.return, 'Day') };

            var valid = (0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'valid');

            var invalidDate = !valid && selectedYear && selectedMonth && selectedDay ? true : false;

            var invalidDay = this.state.validateDay === true && !(0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'validDay');
            var invalidMonth = this.state.validateMonth === true && !(0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'validMonth');
            var invalidYear = this.state.validateYear === true && !(0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'validYear');

            var componentError = invalidDate || invalidDay || invalidMonth || invalidYear;

            return _react2.default.createElement(
                _metrixCommon.Grid,
                null,
                _react2.default.createElement(
                    _metrixCommon.Row,
                    { nogutter: true },
                    _react2.default.createElement(
                        _metrixCommon.Column,
                        { nogutter: true },
                        _react2.default.createElement(_metrixCommon.Label, { text: (0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'Label'),
                            textAlign: _metrixCommon.Alignments.left, error: componentError })
                    )
                ),
                _react2.default.createElement(
                    _metrixCommon.Row,
                    { nogutter: true },
                    _react2.default.createElement(
                        _metrixCommon.Column,
                        { xs: 12, md: 4, nogutter: this.props.mobile, nogutterleft: true },
                        _react2.default.createElement(_metrixCommon.DropDown, {
                            top: _metrixCommon.Sizes.xs,
                            bottom: _metrixCommon.Sizes.xs,
                            placeholder: 'MMM',
                            value: selectedMonth,
                            references: this.state.months,
                            changeEvent: function changeEvent(value) {
                                _this2.props.doSetReturn({
                                    componentCode: _this2.props.componentCode || _this2.props.component.code,
                                    code: 'Month',
                                    value: value.code
                                });
                                _this2.handleDate((0, _metrixCommon.getReturnElementByCode)(_this2.props.return, 'Year'), value.code);
                            },
                            onBlur: function onBlur() {
                                return _this2.setState({ validateMonth: true });
                            },
                            error: invalidDate || invalidMonth,
                            filterMode: false
                        })
                    ),
                    _react2.default.createElement(
                        _metrixCommon.Column,
                        { xs: 6, md: 4, nogutterleft: this.props.mobile },
                        _react2.default.createElement(_metrixCommon.DropDown, {
                            top: _metrixCommon.Sizes.xs,
                            bottom: _metrixCommon.Sizes.xs,
                            placeholder: 'DD',
                            value: selectedDay,
                            references: this.state.days,
                            changeEvent: function changeEvent(value) {
                                _this2.props.doSetReturn({
                                    componentCode: _this2.props.componentCode || _this2.props.component.code,
                                    code: 'Day',
                                    value: value.code
                                });
                            },
                            onBlur: function onBlur() {
                                return _this2.setState({ validateDay: true });
                            },
                            error: invalidDate || invalidDay,
                            filterMode: false
                        })
                    ),
                    _react2.default.createElement(
                        _metrixCommon.Column,
                        { xs: 6, md: 4, nogutterright: true },
                        _react2.default.createElement(_metrixCommon.DropDown, {
                            top: _metrixCommon.Sizes.xs,
                            bottom: _metrixCommon.Sizes.xs,
                            placeholder: 'YYYY',
                            value: selectedYear,
                            references: this.state.years,
                            changeEvent: function changeEvent(value) {
                                _this2.props.doSetReturn({
                                    componentCode: _this2.props.componentCode || _this2.props.component.code,
                                    code: 'Year',
                                    value: value.code
                                });
                                _this2.handleDate(value.code, (0, _metrixCommon.getReturnElementByCode)(_this2.props.return, 'Month'));
                            },
                            onBlur: function onBlur() {
                                return _this2.setState({ validateYear: true });
                            },
                            error: invalidDate || invalidYear,
                            filterMode: false
                        })
                    )
                ),
                invalidDate && _react2.default.createElement(
                    _metrixCommon.Row,
                    { nogutter: true },
                    _react2.default.createElement(
                        _metrixCommon.Column,
                        { nogutter: true },
                        _react2.default.createElement(_metrixCommon.Label, { text: (0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'Error'),
                            textAlign: _metrixCommon.Alignments.left, color: _metrixCommon.Colors.Error })
                    )
                )
            );
        }
    }]);

    return WorkflowDate;
}(_react2.default.Component);

exports.default = WorkflowDate;